import { BundleChargingModel } from 'modules/billing/types';
import { ProgressBar } from 'modules/common/components/ProgressBar';
import { getDateFromUnixSeconds } from 'modules/common/utils/getDateFromUnixSeconds';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { getColor } from './utils/getColor';
import { bundleProgressBarTranslation } from './translation';
import { BundleProgressLabel } from './components/BundleProgressLabel';

export interface BundleProgressBarProps {
  chargingModel: BundleChargingModel;
  isShortened?: boolean;
}

export const BundleProgressBar = ({
  chargingModel,
  isShortened,
}: BundleProgressBarProps) => {
  const { keys, t } = useTranslation(bundleProgressBarTranslation);

  const maxLabelKey =
    chargingModel.type === 'freemium' ? keys.renew : keys.expire;

  const color = getColor(chargingModel.usage.leftPercent);

  return (
    <ProgressBar
      color={color ?? 'primary'}
      max={100}
      maxLabel={t(maxLabelKey, {
        date: getDateFromUnixSeconds(chargingModel.expires),
      })}
      progress={chargingModel.usage.leftPercent}
      progressLabel={
        <BundleProgressLabel
          chargingModel={chargingModel}
          color={color}
          isShortened={isShortened}
        />
      }
      variant={isShortened ? 'small' : 'medium'}
    />
  );
};
